namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmDenikSslStrediskoSpisovychUzlu extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmDenikSslStrediskoSpisovychUzluReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmDenikSslStrediskoSpisovychUzluObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmDenikSslStrediskoSpisovychUzluObj());
            this.detailObj.createBase({
                contentName: "detailAdmDenikSslStrediskoSpisovychUzlu",
                contentCaption: "jres:33000625", //RC 33000625 : Navázané středisko spis. uzlů na deník
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmDenikSslStrediskoSpisovychUzlu", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmDenikSslStrediskoSpisovychUzluObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmDenikSslStrediskoSpisovychUzluReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return "{0} - {1}".format(this.data["sslden"]?.toString(), this.data["ixs_tre"]?.toString()) 
        }

        setSxsDetail(): string {
            return "{0}#{1}#{2}#".format((this.data.ixs_tre) ? this.data.ixs_tre.toString() : "", (this.data.sslden) ? this.data.sslden.toString() : "", (this.data.subrada) ? this.data.subrada.toString() : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmDenikSslStrediskoSpisovychUzluSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            data.subrada = 1;
            (this.cnt.isl.AdmDenikSslStrediskoSpisovychUzlu.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmDenikSslStrediskoSpisovychUzlu", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmDenikSslStrediskoSpisovychUzlu.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, this.textPopis()?.toString());
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("sslden", Gordic.Prefabs.Select.sslsden(), {
                model: "model.sslden=value.sslden",
                itemTemplate: "{sslden}"
            })
            this.MakeSelectField("ixs_tre", Gordic.Prefabs.Select.ginstre(), {
                model: "model.ixs_tre=value.ixs_tre",
                dropdown: false
            });
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt(), { model: "model.aktivita=value.aktivita" })
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
            this.MakeField("dat_zmena");
        }
    }
}